exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-not-found-container {\n  margin-top: 25rem;\n  text-align: center;\n  font-size: 3rem; }\n  .user-not-found-container .not-found {\n    font-size: 3rem; }\n", ""]);

// exports
